/* import __COLOCATED_TEMPLATE__ from './priority-button.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';
import { type ConversationRecord } from 'embercom/objects/inbox/types/conversation-record';

interface Signature {
  Args: {
    conversationToAction: ConversationRecord;
    togglePriority: () => void;
  };
}

const PriorityButton = templateOnlyComponent<Signature>();
export default PriorityButton;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationPanel::PriorityButton': typeof PriorityButton;
    'inbox2/conversation-panel/priority-button': typeof PriorityButton;
  }
}
